import React, { Component } from 'react'
import { connect } from 'react-redux'
import PageTitle from '../../../components/ui/typography/PageTitle'
import DemoClientInfoForm from './components/DemoClientInfoForm'

class AuthenticatedDemoIndex extends Component {
  render() {
    const { audited, dimName, logo, schoolCatalog, shortName } = this.props
    return (
      <div className="main-page">
        <div>
          <PageTitle
            content="Demo"
          />
          <div className="row">
            <div className="col-xl-10 offset-xl-1">
              <DemoClientInfoForm
                initialValues={{
                  audited,
                  dimName,
                  logo,
                  schoolCatalog,
                  shortName
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  audited: state.demo.audited,
  dimName: state.demo.dimName,
  logo: state.demo.logo,
  schoolCatalog: state.demo.schoolCatalog,
  shortName: state.demo.shortName,
})

export default connect(mapStateToProps) (AuthenticatedDemoIndex)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Demo/AuthenticatedDemoIndex.js